import { useState } from 'react'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import Permissoes from '../../middleware/Permissoes'
import SubMenuOpcoes from '../SubMenuOpcoes'
import '../../styles/menuopcoes.css'

function MenuFinanceiro (props: menuOpcoes) {

    const [subMenu, setSubMenu] = useState(false)

    function exibirSubmenu () {
        setSubMenu (subMenu => !subMenu)
    }

    return (
        <Permissoes permissoes={['master', 'administrativo', 'financeiro_acesso']}>
            <div>
                <div id = 'menuOpcoes' onClick={exibirSubmenu}>
                    {<img id = 'iconeMenu' src= {props.icone} alt = {props.alt}></img>}
                    <p id = 'tituloMenu'>{props.titulo}</p>
                </div>
                <div id = 'submenuOpcoes'>
                    <Permissoes permissoes={['master', 'administrativo', 'financeiro_assinatura']}>
                        {subMenu && <SubMenuOpcoes redirect={'/assinaturas?tipo=receita'} texto='Assinaturas' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'financeiro_receita']}>
                        {subMenu && <SubMenuOpcoes redirect={'/lancamentos?tipo=receita'} texto='Receitas' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'financeiro_despesa']}>
                        {subMenu && <SubMenuOpcoes redirect={'/lancamentos?tipo=despesa'} texto='Despesas' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'financeiro_despesa_recorrente']}>
                        {subMenu && <SubMenuOpcoes redirect={'/assinaturas?tipo=despesa'} texto='Despesas Recorrentes' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'financeiro_clientes_inadimplentes']}>
                        {subMenu && <SubMenuOpcoes redirect = {'/lancamentos?tipo=receita&inadimplencia=true'} texto = 'Clientes Inadimplentes' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'financeiro_contas']}>
                        {subMenu && <SubMenuOpcoes redirect = {'/contas'} texto = 'Contas Bancárias' />}
                    </Permissoes>
                </div>
            </div>
        </Permissoes>
    )
}

export default MenuFinanceiro